module.exports = __webpack_public_path__ + "img/picture.282e41c3.png";